import { render, staticRenderFns } from "./ContactRegisterReportTable.vue?vue&type=template&id=2037adb8&scoped=true&"
import script from "./ContactRegisterReportTable.vue?vue&type=script&lang=js&"
export * from "./ContactRegisterReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactRegisterReportTable.vue?vue&type=style&index=0&id=2037adb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037adb8",
  null
  
)

export default component.exports